import { render, staticRenderFns } from "./DialogAddMatching.vue?vue&type=template&id=44148bf6"
import script from "./DialogAddMatching.vue?vue&type=script&lang=js"
export * from "./DialogAddMatching.vue?vue&type=script&lang=js"
import style0 from "./DialogAddMatching.vue?vue&type=style&index=0&id=44148bf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports